import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=a2ef61e6&scoped=true&"
import script from "./refundDetail.vue?vue&type=script&lang=js&"
export * from "./refundDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=a2ef61e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ef61e6",
  null
  
)

export default component.exports